<template>
  <div class="form-wrapper termination-form">
    <slot name="txtCustomerInfo"></slot>
    <b-form
      :id="'form' + _uid" :novalidate="true"
      class="termination-input-form"
      ref="form">
      <div class="field-group">
        <h2 class="h3"><slot name="txtFormHeadline"></slot></h2>
        <div class="form-row">
          <LabeledTextInput
            name="firstName"
            :model.sync="formValues.address.firstName"
            :invalid.sync="invalid.address.firstName"
            :validation="validations.firstName"
            :formatter="formatterCharFilterOnlyAplha"
            :mandatory="false"
            placeholder="Max"
            ref="nestedInputFirstName"
          >
            <template v-for="slot in possibleChildSlotsFor('FirstName')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledTextInput>
          <LabeledTextInput
            name="lastName"
            :model.sync="formValues.address.lastName"
            :mandatory="false"
            :invalid.sync="invalid.address.lastName"
            :validation="validations.lastName"
            :formatter="formatterCharFilterOnlyAplha"
            placeholder="Mustermann"
            ref="nestedInputLastName"
          >
            <template v-for="slot in possibleChildSlotsFor('LastName')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledTextInput>
        </div>
        <div class="form-row">
          <LabeledTextInput
            name="street"
            :model.sync="formValues.address.street"
            :invalid.sync="invalid.address.street"
            :validation="validations.street"
            :mandatory="false"
            placeholder="Musterstraße"
            ref="nestedInputStreet"
            width="75"
          >
            <template v-for="slot in possibleChildSlotsFor('Street')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledTextInput>
          <LabeledTextInput
            name="houseNumber"
            :model.sync="formValues.address.houseNumber"
            :mandatory="false"
            :invalid.sync="invalid.address.houseNumber"
            :validation="validations.houseNumber"
            placeholder="1a"
            ref="nestedInputHouseNumber"
            width="25"
          >
            <template v-for="slot in possibleChildSlotsFor('HouseNumber')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledTextInput>
        </div>
        <div class="form-row">
          <LabeledTextInput
            name="zip"
            :model.sync="formValues.address.zip"
            :invalid.sync="invalid.address.zip"
            :validation="validations.zip"
            :formatter="zipFormatter"
            :mandatory="false"
            placeholder="12345"
            ref="nestedInputZip"
            width="25"
          >
            <template v-for="slot in possibleChildSlotsFor('Zip')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledTextInput>
          <LabeledTextInput
            name="city"
            :model.sync="formValues.address.city"
            :mandatory="false"
            :invalid.sync="invalid.address.city"
            :validation="validations.city"
            :formatter="formatterCharFilterOnlyAplha"
            placeholder="Musterstadt"
            ref="nestedInputCity"
            width="75"
          >
            <template v-for="slot in possibleChildSlotsFor('City')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledTextInput>
        </div>
        <div class="form-row">
          <LabeledTextInput
            name="email"
            :model.sync="formValues.customer.email"
            :mandatory="false"
            type="email"
            :invalid.sync="invalid.customer.email"
            :validation="validations.email"
            placeholder="max.mustermann@muster.de"
            ref="nestedInputEmail"
          >
            <template v-for="slot in possibleChildSlotsFor('Email')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledTextInput>
          <LabeledTextInput
            name="customerId"
            :model.sync="formValues.customer.terminationId.customerId"
            :mandatory="false"
            type="text"
            :invalid.sync="invalid.customer.customerId"
            :validation="validations.customerId"
            :formatter="zipFormatter"
            placeholder="123456789"
            ref="nestedInputCustomerId"
          >
            <template v-for="slot in possibleChildSlotsFor('CustomerId')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledTextInput>
        </div>
        <div class="form-row">
          <LabeledTextInput
            name="contractId"
            :model.sync="formValues.customer.terminationId.msisdnOrContractId"
            :mandatory="false"
            :invalid.sync="invalid.customer.msisdnOrContractId"
            :validation="validations.contractId"
            :formatter="contractIdFormatter"
            placeholder="2200123456 oder 0172 1234567"
            ref="nestedInputContractId"
          >
            <template v-for="slot in possibleChildSlotsFor('ContractId')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledTextInput>
          <b-form-group :class="['fieldset-date', vflowGetFeedbackClasses('formValues.customer.terminationData.date'), 'date-group', 'info-icon']">
            <div class="fieldset--label">
              <label @mousedown="isLabelClicked = true" @blur="isLabelClicked = false" for="date">
                <slot name="lblDate">Gewünschter Kündigungstermin</slot>
              </label>
              <button type="button" aria-haspopup="dialog" :aria-label="slotAltTagLabelIcon" class="icon-only"  @click="showInfoModal = true">
                <img src="files/flash/images/svg-icons/info-icon.svg">
              </button>
            </div>
              <b-form-input
                id="date"
                :key="'DateInputField' + refreshKeyDate"
                v-model="formValues.customer.terminationData.date"
                @mousedown="isFocusedWithoutClick = false; isClicked = true"
                @blur="vflowInputBlurred('formValues.customer.terminationData.date'); blurredDate(); isClicked = false; isFocusedWithoutClick = false"
                @click="clickedDate"
                @focus="focusedDate(); vflowInputFocused('formValues.customer.terminationData.date'); onFocus()"
                @input.native="handleInputDate"
                @keydown="keypressDate"
                aria-describedby="errmsg-date"
                :aria-invalid="dateInvalid"
                autocomplete="off"
                :class="['date-type-assisted', isFocusedWithoutClick ? 'is-focus-visible' : '']"
                name="date"
                :placeholder="slottedDate"
                ref="inputDate"
                type="text"
              ></b-form-input>
              <b-form-invalid-feedback id="errmsg-date" role="alert"
                v-if="dateInvalid">
                <slot name="txtInvalidBirthDateLiveFeedback">Dies ist kein gültiges Datum.</slot>
              </b-form-invalid-feedback>
            </b-form-group>
          <SimonModal :is-visible="showInfoModal" @hide="showInfoModal = false" id="date-info-modal">
            <slot name="txtInfoModalDate"></slot>
          </SimonModal>
        </div>
        <div class="form-row">
          <LabeledTextInput
            name="details"
            :model.sync="formValues.customer.terminationData.details"
            :mandatory="false"
            :invalid.sync="invalid.customer.details"
            :validation="validations.details"
            ref="nestedInputDetails"
            placeholder="Hier kannst Du uns weitere Informationen zu Deiner Kündigung mitteilen."
            type="textarea"
          >
            <template v-for="slot in possibleChildSlotsFor('Details')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledTextInput>
        </div>
      </div>

      <div class="termination-captcha card card--grey">
        <slot name="txtBeforeCaptcha"></slot>
        <div class="form-row">
          <LabeledTextInput
            name="captcha"
            :model.sync="captcha.value"
            :invalid.sync="invalid.captcha"
            :validation="validations.captcha"
            :mandatory="false"
            forma="numeric"
            placeholder=""
            required
            ref="nestedInputCaptcha"
          >
            <template v-for="slot in possibleChildSlotsFor('Captcha')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledTextInput>
          <div class="captcha-image">
            <img :src="imageSrc" alt="Sicherheitscode: Bitte gib die hier gezeigten Zeichen in das Eingabefeld ein. Du kannst dir diese auch vorlesen lassen.">
          </div>
          <div class="button-wrapper">
            <div v-if="this.captcha.audio" class="captcha-audio-wrapper">
              <audio controls type="audio/wav" id="captcha-audio" :src="audioSrc">
                Dein Browser unterstützt das Abspielen dieser Audiodatei nicht.
              </audio>
            </div>
            <button type="button" class="captcha-refresh-button" @click="refreshCaptcha" :aria-label="this.getSlotText('txtAriaLabelCaptchaRefresh', 'Neuen Sicherheitscode anzeigen')">
            <img src="/files/flash/images/svg-icons/icon-reload.svg" alt="" aria-hidden="true"/>
          </button>
            <button type="button" class="captcha-audio-button" @click="playAudioCaptcha" :aria-label="this.getSlotText('txtAriaLabelCaptchaAudio', 'Sicherheitscode vorlesen')">
            <img src="/files/flash/images/svg-icons/icon-audio.svg" alt="" aria-hidden="true"/>
          </button>
          </div>
        </div>
      </div>
      <div class="termination-text-before-submit">
        <slot name="txtBeforeSubmit">Bevor du kündigst, lass uns reden! Hier findest du die passenden Informationen.</slot>
      </div>
      <Stepper
        :show-prev="false"
        @next="submit()"
        :disabled-next="loading"
        :disabled-prev="loading"
      >
        <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Stepper>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/validators/isValid'
import validationFlow from '@/mixins/validators/validationFlow'
import formatterCharFilterOnlyAplha from '@/mixins/formatters/inputFormatter'
import formatDecimal from '@/mixins/formatters/formatDecimal'
import transaction from '@/mixins/transaction'

import beErrors from '@/mixins/beErrors'
import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import emailValidator from '@/mixins/validators/emailValidator'
import LabeledTextInput from '@/components/forms/LabeledTextInput.vue'
import Stepper from '@/components/generic/Stepper'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import googleAutocomplete from '@/mixins/googleAutocomplete'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import { mapMutations } from 'vuex'
import date from '@/mixins/validators/date'
import SimonModal from '@/components/modal/SimonModal.vue'

const isValidCustomerId = (v) => (v === null || /^[0-9]*$/.test(v))
const zipValidator = /^\d{5}$/
const isValidZipCode = (v) => (v === null || zipValidator.test(v))
const zipFormatter = (v) => v.replace(/[^\d]/g, '')
const contractIdFormatter = (v) => v.replace(/[^\d\s\+\/]/g, '') // eslint-disable-line
const houseNoValidator = /^(\d{1,5})$|^(\d{1,4}([a-zA-Z]))$|^(((\d{1,5})|(\d{1,4}([a-zA-Z])))-((\d{1,5})|(\d{1,4}([a-zA-Z]))||([a-zA-Z])))$/
const isValidHouseNo = (v) => (v === null || houseNoValidator.test(v))

export default {
  name: 'TerminationForm',
  components: { SimonModal, Stepper, LabeledTextInput },
  data  () {
    return {
      loading: false,
      updateDate: false,
      refreshKeyDate: 0,
      showInfoModal: false,
      isClicked: false,
      isLabelClicked: false,
      isFocusedWithoutClick: false,
      formValues: {
        address: {
          firstName: null,
          lastName: null,
          street: null,
          houseNumber: null,
          zip: null,
          city: null
        },
        customer: {
          email: '',
          terminationId: {
            customerId: null,
            msisdnOrContractId: null
          },
          terminationData: {
            date: 'frühestmöglich',
            details: null
          }
        }
      },
      captcha: {
        value: null,
        image: null,
        token: null,
        audio: null
      },
      invalid: {
        address: {
          firstName: null,
          lastName: null,
          street: null,
          houseNumber: null,
          zip: null,
          city: null
        },
        customer: {
          email: null,
          customerId: null,
          msisdnOrContractId: null,
          date: null,
          details: null
        },
        captcha: null
      },
      validations: {
        firstName: {
          maxLength: maxLength(50)
        },
        lastName: {
          maxLength: maxLength(50)
        },
        street: {
          maxLength: maxLength(50)
        },
        houseNumber: {
          maxLength: maxLength(9),
          isValidHouseNo
        },
        zip: {
          isValidZipCode
        },
        city: {
          maxLength: maxLength(50)
        },
        email: {
          maxLength: maxLength(70)
        },
        customerId: {
          maxLength: maxLength(70),
          isValidCustomerId
        },
        contractId: {
          maxLength: maxLength(70)
        },
        details: {
          maxLength: maxLength(700)
        },
        captcha: {
          required,
          maxLength: maxLength(3),
          minLength: minLength(3)
        }
      }
    }
  },
  mounted () {
    this.startLoader()
    this.resetTerminationState()
    this.initiateAutocomplete(this.autocompleteCallback)
    this.stopLoader()
  },
  computed: {
    slotOptions: function () {
      return this.getSlotListToArray('optionsReason')
    },
    fallbackErrorMessage: function () {
      return this.getSlotText('txtToastError', 'Es ist ein technischer Fehler aufgetreten.')
    },
    slotAltTagLabelIcon: function (name) {
      const altTag = 'Weitere Informationen zum Eingabefeld ' + this.getSlotText('lblDate')
      return this.getSlotText('txtInfoIconAlt', altTag)
    },
    slottedDate: function () {
      return this.$slots.txtPlaceholderDate?.[0]?.text || 'TT.MM.JJJJ'
    },
    imageSrc: function () {
      return 'data:image/png;base64, ' + this.captcha.image
    },
    audioSrc: function () {
      return 'data:audio/wav;base64, ' + this.captcha.audio
    },
    formInvalid: function () {
      return !this.captcha.value
    },
    dateInvalid: function () {
      return !this.$v.formValues.customer.terminationData.date.hasValidDateFormat
    }
  },
  methods: {
    ...mapMutations('termination', [
      'saveTerminationResponse',
      'resetTerminationState'
    ]),
    submit () {
      const comp = this
      comp.loading = true
      this.forceValidationOnNestedInputs()
      if (this.formInvalid) {
        comp.loading = false
        this.vFlowScrollToFirstElemment()
        this.vFlowGetFirstErrorElementName().then(function (result) {
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
        return
      }
      this.startLoader()

      comp.sendForm()
        .then(() => {
          this.stopLoader()
        })
        .catch((e) => {
          this.stopLoader()
          throw e
        })
    },
    forceValidationOnNestedInputs () {
      this.vflowForceFeedback()
      Object.entries(this.$refs).forEach(([key, comp]) => {
        if (/^nestedInput/.test(key)) {
          comp.vflowForceFeedback()
        }
      })
    },
    sendForm () {
      const comp = this
      return this.$apollo.mutate(({
        mutation: gql`mutation terminationForm ($terminationInput: ContractTerminationInput!) {
          contractTermination(contractTermination: $terminationInput) {
            address {
              firstName
              lastName
              street
              houseNumber
              zip
              city
            }
            customer {
              email
              terminationId {
                customerId
                msisdnOrContractId
              }
              terminationData {
                date
                details
              }
            }
            createdAt
            caseNumber
            document {
              document
              type
            }
            success
          }
        }`,
        variables: {
          terminationInput: {
            brand: 'simon',
            address: {
              ...comp.formValues.address
            },
            customer: {
              ...comp.formValues.customer
            },
            captcha: {
              code: comp.captcha.value,
              token: comp.captcha.token
            }
          }
        }
      })).then((data) => {
        this.saveTerminationResponse(data.data.contractTermination)
        window.location.href = this.successUrl
      }).catch((error) => {
        comp.clearToasts()
        comp.errorToast(this.errorMessage(error))
        comp.loading = false
        this.captcha.value = ''
        this.$apollo.queries.captcha.refetch()
      })
    },
    clearForm () {
      const comp = this
      this.vflowResetFeedbackStates()
      Object.entries(this.$refs).forEach(([key, comp]) => {
        if (/^nestedInput/.test(key)) {
          comp.vflowResetFeedbackStates()
        }
      })
      // Don't aks me why... we need to reset the feedback state first and
      // then clear all the input values
      Object.keys(this.formValues.address).forEach((key) => {
        comp.formValues.address[key] = null
      })
      comp.formValues.customer = {
        email: '',
        terminationId: {
          customerId: null,
          msisdnOrContractId: null
        },
        terminationData: {
          date: 'frühestmöglich',
          details: null
        }
      }
      comp.formValues.captcha.value = null
      this.$apollo.queries.captcha.refetch()
    },
    errorMessage (error) {
      const firstMessage = splitError(error)?.[0] || error
      if (firstMessage.networkError) {
        return 'Ufff! Leider ist die Verbindung gerade abgebrochen (Fehler: L1). Bitte probier\'s gleich noch einmal.'
      }
      if (firstMessage && firstMessage.extensions?.category === 'graphql') {
        // technical error message, do not use for customer
        return this.fallbackErrorMessage
      }
      return firstMessage.message
    },
    refreshCaptcha (e) {
      e.preventDefault()
      this.$apollo.queries.captcha.refetch()
      this.$refs.nestedInputCaptcha.vflowResetFeedbackStates()
    },
    playAudioCaptcha () {
      document.getElementById('captcha-audio').play()
    },
    filterDateInput (e) {
      const keyCode = e.which || e.code
      let key = e.key
      const validKeyCodes = [
        37, // ArrowLeft
        39, // ArrowRight
        8, // Backspace
        46, // Delete
        36, // Home
        35, // End
        9 // Tab
      ]

      // if we are on android
      if (key === 'Unidentified') {
        return false
      }

      if (!key) {
        key = String.fromCharCode(keyCode)
      }

      if (!/[0-9.]/.test(key) && validKeyCodes.indexOf(keyCode) === -1) {
        e.preventDefault()
        e.stopPropagation()
      }
    },
    handleDateKeypress (v, e, startPos) {
      this.filterDateInput(e)
      if (e.key === '.') {
        const afterDotResult = v.substring(0, startPos) + '.' + v.substring(startPos)
        const numDots = (v.match(/\./g) || []).length
        let prevent = (afterDotResult.indexOf('..') !== -1 || numDots > 2)

        // check if user will be between dots
        if (prevent && numDots === 1) {
          if (v.substring(startPos + 1, startPos) === '.') {
            prevent = false
          }
        }

        if (prevent) {
          e.preventDefault()
          e.stopPropagation()
          return false
        }
      }
    },
    keypressDate (e) {
      this.handleDateKeypress(this.formValues.customer.terminationData.date, e, this.$refs.inputDate.selectionStart)
      const triggerKeys = ['Home', 'End', 'Tab']
      if (triggerKeys.indexOf(e.key) !== -1) {
        this.updateDate = true
        this.formatDate(this.formValues.customer.terminationData.date)
      }
    },
    handleInputDate (e) {
      if (e.target.value === 'frühestmöglich') {
        return
      }
      if (/[^0-9.]+/.test(e.target.value)) {
        const v = e.target.value.replace(/([^0-9.])/g, '').trim()
        setTimeout(() => {
          this.formValues.customer.terminationData.date = v
          this.formatDate(this.formValues.customer.terminationData.date)
          this.blurredDate()
          this.$nextTick(() => {
            this.$refs.inputDate.$el.focus()
          })
        }, 250)
      } else if (e.inputType !== 'deleteContentBackward') {
        this.formatDate(e.target.value)
      }
    },
    clickedDate (e) {
      const startPos = this.$refs.inputDate.selectionStart
      if (startPos >= this.formValues.customer.terminationData.date.length) {
        this.formatDate(this.formValues.customer.terminationData.date)
      }
    },
    blurredDate () {
      this.refreshKeyDate += 1
      if (this.formValues.customer.terminationData.date === '') {
        this.$nextTick(() => {
          this.updateDate = false
          this.formValues.customer.terminationData.date = 'frühestmöglich'
          this.$v.formValues.customer.terminationData.date.$touch()
        })
      } else {
        this.formatDate(this.formValues.customer.terminationData.date)
      }
    },
    formatDate (v) {
      const force = this.vflowIsBlurred('formValues.customer.terminationData.date')
      const startPos = this.$refs.inputDate.selectionStart
      const update = (this.isFormatableDate(v) && (this.updateDate || force || startPos >= v.length))
      if (update) {
        this.$nextTick(() => {
          this.updateDate = false
          this.formValues.customer.terminationData.date = this.formatDateExpression(v)
          this.$v.formValues.customer.terminationData.date.$touch()
        })
      } else {
        this.formValues.customer.terminationData.date = v
        this.$v.formValues.customer.terminationData.date.$touch()
      }
    },
    focusedDate () {
      if (this.formValues.customer.terminationData.date === 'frühestmöglich') {
        this.formValues.customer.terminationData.date = ''
      }
    },
    formatDateExpression (v, event) {
      // replace all invalid characters
      const dv = (v !== null) ? v.replace(/([^0-9.])/g, '').trim() : ''

      // split into date parts
      const m = dv.match(/^(3[01]|[12][0-9]|0?[1-9])(\.*)(1[0-2]|0?[1-9])?(\.*)(\d{1,4})?$/)
      if (m !== null) {
        const inpDay = (typeof m[1] !== 'undefined' ? m[1] : null)
        const dotDay = (typeof m[2] !== 'undefined' ? (m[2] === '.') : false)
        const inpMonth = (typeof m[3] !== 'undefined' ? m[3] : null)
        const dotMonth = (typeof m[4] !== 'undefined' ? (m[4] === '.') : false)
        const inpYear = (typeof m[5] !== 'undefined' ? m[5] : null)

        const day = parseInt(inpDay)
        const month = parseInt(inpMonth)

        const dayComplete = inpDay !== null && (inpDay.length === 2 || dotDay || parseInt(inpDay.substr(0, 1)) > 3)
        const monthComplete = inpMonth !== null && (dayComplete && (inpMonth.length === 2 || dotMonth || parseInt(inpMonth.substr(0, 1)) > 1))

        let de = ''
        if (dayComplete) {
          de = (day < 10 ? '0' + day.toString() : day) + '.'
        } else {
          de = (inpDay !== null ? inpDay : '')
        }

        if (monthComplete) {
          de = de + (month < 10 ? '0' + month.toString() : month) + '.'
        } else {
          de = de + (inpMonth !== null ? inpMonth : '')
        }

        de = de + (inpYear !== null ? inpYear : '')

        return de
      }

      return v
    },
    isFormatableDate (v) {
      // replace all invalid characters
      const dv = (v !== null) ? v.replace(/([^0-9.])/g, '').trim() : ''

      // split into date parts
      const m = dv.match(/^(3[01]|[12][0-9]|0?[1-9])(\.*)(1[0-2]|0?[1-9])?(\.*)(\d{1,4})?$/)
      if (m !== null) {
        return true
      }

      return false
    },
    autocompleteCallback () {
      this.setupAutocompleteHandler(document.getElementById('street'))
    },
    performAutocomplete () {
      this.formValues.address.zip = ''
      this.formValues.address.houseNumber = ''
      this.formValues.address.city = ''
      this.formValues.address.street = ''
      const place = this.autocompleteHandler.getPlace()
      // Get each component of the address from the place details,
      // and then fill-in the corresponding field on the form.
      // place.address_components are google.maps.GeocoderAddressComponent objects
      // which are documented at http://goo.gle/3l5i5Mr
      if (place.address_components === undefined || place.address_components.length <= 0) {
        this.errorToast(this.getSlotText('txtGoogleAutocompleteError'))
        return
      }
      for (const component of place.address_components) {
        const componentType = component.types[0]

        switch (componentType) {
          case 'street_number': {
            this.formValues.address.houseNumber = component.long_name
            break
          }
          case 'postal_code': {
            this.formValues.address.zip = component.long_name
            break
          }
          case 'locality': {
            this.formValues.address.city = component.long_name
            break
          }
          case 'route': {
            // Add short delay on rout to avoid race conditions with google autocomplete
            const _this = this
            setTimeout(() => { _this.formValues.address.street = component.long_name }, 5)
            break
          }
        }
      }
      if (this.formValues.address.houseNumber === '') {
        document.getElementById('houseNumber').focus()
      } else if (this.formValues.address.zip === '') {
        document.getElementById('zip').focus()
      }
    },
    onFocus () {
      if (!this.isClicked && !this.isLabelClicked) {
        this.isFocusedWithoutClick = true
      }
      this.isLabelClicked = false
    }
  },
  mixins: [
    validationMixin,
    emailValidator,
    isValid,
    validationFlow,
    formatterCharFilterOnlyAplha,
    formatDecimal,
    transaction('contactForm'),

    beErrors,
    googleAutocomplete(),
    date
  ],
  import: {
    zipFormatter,
    contractIdFormatter
  },
  validations () {
    return {
      formValues: {
        customer: {
          terminationData: {
            date: {
              hasValidDateFormat (v) {
                return v === 'frühestmöglich' || this.validDateFormatOnlyForNonEmpty(this.formatDateExpression(v))
              },
              hasValidDate (v) {
                return v === 'frühestmöglich' || this.validDate(this.formatDateExpression(v))
              }
            }
          }
        }
      }
    }
  },
  apollo: {
    captcha: function () {
      return wrapQuery(
        gql`query captcha {
          captcha (brand: "simon"){
            image
            token
            audio
          }
        }`, this, 'captcha', {}, (data) => {
          this.loading = false
          this.captcha = data
        },
        { fetchPolicy: 'no-cache' },
        (error) => {
          this.errorToast(this.errorMessage(error))
          this.loading = false
        }
      )
    }
  },
  props: {
    successUrl: {
      Type: String,
      default: '/vertrag-kuendigen/danke'
    }
  }
}
</script>
